import React, { ReactChild } from 'react';
import styled from 'styled-components';
import ButtonSpinner from '../loading-indicators/button-spinner';

const StyledButton = styled.button.attrs(() => ({}))<{
  isLoading?: boolean;
  secondary?: boolean;
  big?: boolean;
  fullWidthMobile?: boolean;
}>`
  height: ${(props) => (props.big ? '56px' : '32px')};
  width: min-content;
  padding: 0px ${(props) => (props.big ? '32px' : '24px')};
  background: ${(props) =>
    props.secondary ? 'var(--primary-text-color)' : 'var(--primary-color)'};
  opacity: ${(props) => (props.isLoading ? '0.5' : '1')};
  border-radius: 2px;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  cursor: ${(props) => (props.isLoading ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  @media (max-width: 640px) {
    width: ${(props) => (props.fullWidthMobile ? '100%' : 'min-content')};
  }
`;

const ButtonText = styled.span.attrs(() => ({}))<{
  secondary?: boolean;
}>`
  color: ${(props) => (props.secondary ? 'var(--primary-color)' : 'var(--primary-text-color)')};
`;

const Button = (props: {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children?: ReactChild;
  loading?: boolean;
  inactive?: boolean;
  secondary?: boolean;
  big?: boolean;
  className?: string;
  fullWidthMobile?: boolean;
  style?: React.CSSProperties | undefined;
}): JSX.Element => {
  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    if (!props.loading && !props.inactive) {
      props.onClick(event);
    }
  };

  return (
    <StyledButton
      onClick={handleOnClick}
      isLoading={props.loading || props.inactive}
      secondary={props.secondary}
      big={props.big}
      className={props.className}
      fullWidthMobile={props.fullWidthMobile}
      style={props.style}
    >
      {props.loading && <ButtonSpinner />}
      <ButtonText secondary={props.secondary}>{props.children}</ButtonText>
    </StyledButton>
  );
};

export default Button;
